import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const IconSite = (props) => {
  const { fontSize = '1.5rem', color = 'text.disabled', filled, ...other } = props;

  let svg = (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.59 4.22C15.98 2.74 14.12 2 12 2C9.88 2 8.02 2.74 6.41 4.22C4.8 5.7 4 7.7 4 10.2C4 11.87 4.66 13.68 5.99 15.64C7.32 17.6 9.32 19.72 12 22C14.68 19.72 16.69 17.6 18.01 15.64C19.34 13.68 20 11.87 20 10.2C20 7.7 19.2 5.71 17.59 4.22ZM16.52 14.26C15.54 15.78 14.03 17.48 12 19.35C9.97 17.48 8.46 15.79 7.47 14.26C6.49 12.73 6 11.38 6 10.2C6 8.38 6.58 6.9 7.74 5.74C8.9 4.58 10.32 4 12 4C13.68 4 15.1 4.58 16.26 5.74C17.42 6.9 18 8.39 18 10.2C18 11.38 17.51 12.74 16.52 14.26ZM11 9.16H8V14.16H16V6.08H11V9.16ZM11 12.16H10V11.16H11V12.16ZM13 8.16H14V9.16H13V8.16ZM13 11.16H14V12.16H13V11.16Z"
        fill={color}
      />
    </svg>
  );
  if (filled) {
    svg = (
      <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M17.59 4.22C15.98 2.74 14.12 2 12 2C9.88 2 8.02 2.74 6.41 4.22C4.8 5.7 4 7.7 4 10.2C4 11.87 4.66 13.68 5.99 15.64C7.32 17.6 9.32 19.72 12 22C14.68 19.72 16.69 17.6 18.01 15.64C19.34 13.68 20 11.87 20 10.2C20 7.7 19.2 5.71 17.59 4.22ZM16 14.16H8V9.16H11V6.08H16V14.16Z"
          fill={color}
        />
        <path d="M14.4101 7.76001H12.6001V9.57001H14.4101V7.76001Z" fill={color} />
        <path d="M14.4101 10.76H12.6001V12.57H14.4101V10.76Z" fill={color} />
        <path d="M11.4101 10.76H9.6001V12.57H11.4101V10.76Z" fill={color} />
      </svg>
    );
  }

  return (
    <Box component="span" display="block" height={fontSize} width={fontSize} {...other}>
      {svg}
    </Box>
  );
};

IconSite.propTypes = {
  color: PropTypes.string,
  filled: PropTypes.bool,
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default IconSite;
